<template>
	<div id="print" class="d-none d-print-block">
		<page-1/>

		<page-2/>

		<page-3/>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'

import Page1 from '@/components/print/Page1.vue'
import Page2 from '@/components/print/Page2.vue'
import Page3 from '@/components/print/Page3.vue'

export default {
	components: {
		'Page1': Page1,
		'Page2': Page2,
		'Page3': Page3,
	},
	computed: {
		Character: function(){
			return this.$store.state.Character
		},
		printBio: function(){
			var entries = {}
			for( const entry in this.$store.state.Character.Bio ){
				if( !['Image','Race','ShortDescription'].includes(entry) ){
					entries[entry] = this.$store.state.Character.Bio[entry]
				}
			}
			return entries
		},
		
		...mapGetters([
			'abilityScores',
			'abilityMods',
			'currentLevel',
			'usedArmorUpgradeSlots',
			'previousLevels',
			'totalHitPoints',
			'totalStaminaPoints',
			'totalResolvePoints',
			'hasPools',
		]),
		...mapGetters('character/skills',{
			skillsUsed: 'used',
			skillsRanks: 'ranks',
			skillsOther: 'other',
			skillsTotal: 'total',

		}),
		...mapGetters('character/drones',{
			hasDrone: 'hasDrone',
			droneAbilityScores: 'abilityScores',
			droneMods: 'mods',
			droneFeats: 'feats',
		}),
		...mapGetters('character/companions',[
			'hasCompanion',
		]),
		...mapGetters('character/spells',{
			isCaster: 'isCaster',
			spellsKnown: 'known',
			spellsList: 'list',
			spellsPerDay: 'perDay',
			spellsSaveDC: 'saveDC',
		}),
		...mapGetters('character/equipment',[
			'hasArmorUpgrades',
			'dexToAC',
			'totalArmor',
			'totalAttack',
			'calcWealth',
			'totalCarried',
		])
	}
}
</script>

<style scoped>

</style>